// extracted by mini-css-extract-plugin
export var modal = "_dm-0";